const minHeightCss = { minHeight: '24px' }

export default minHeightCss
